<template>
  <div style="display: flex; flex-direction: column; align-items: center">
    <h2 class="section-header">Nəzarətçinin rəyi</h2>

    <a-table
      :columns="assetmentColumns"
      :rowKey="(record) => record.id"
      :dataSource="dataSource"
      size="middle"
      :pagination="pagination"
      :locale="mylocale"
      style="width: 100%"
    >
      <template slot="fullName" slot-scope="text, recod">
        {{
          recod.opUser.firstName +
          " " +
          recod.opUser.lastName +
          " " +
          recod.opUser.fatherName +
          " (" +
          recod.step.name +
          ")"
        }}
      </template>
      <template slot="action" slot-scope="text, recod">
        <a-button
          type="default"
          v-if="recod.files && recod.files.length > 0"
          size="small"
          @click="showFiles(recod.files)"
          >Fayllara bax</a-button
        >
        <span v-else>Fayl yoxdur</span>
      </template>
    </a-table>

    <!--media dialog-->
    <a-modal
      title="Müraciətə əlavə olunmuş fayllar"
      v-model="mediadialogVisibility"
      :footer="null"
      :width="980"
      centered
    >
      <conditional-media :filesList="files"></conditional-media>
    </a-modal>
  </div>
</template>

<script>
const assetmentColumns = [
  {
    title: "Adı, soyadı",
    width: "25%",
    scopedSlots: { customRender: "fullName" },
  },
  { title: "Rəy", width: "20%", dataIndex: "status.name" },
  { title: "Tarix", width: "20%", dataIndex: "opDataStr" },
  { title: "Fayllar", width: "10%", scopedSlots: { customRender: "action" } },
];
export default {
  name: "Assestment",
  props: { dataSource: Array },
  data() {
    return {
      assetmentColumns,
      files: [],
      mediadialogVisibility: false,
      pagination: { pageSize: 2 },
      mylocale: { emptyText: "Məlumat yoxdur" },
    };
  },
  methods: {
    showFiles(files) {
      this.files = files;
      this.mediadialogVisibility = true;
    },
  },
  created() {
    if (!this.dataSource) return;
    const pagination = { ...this.pagination };
    pagination.total = this.dataSource.length;
    this.pagination = pagination;
  },
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
